module.exports = {
    Description: {
        StaticInfo: `
        <p>
        An Initial Screening is a preliminary assessment of the suitability of a reservoir for a specific development
        process, operational procedure or methodology
        </p>
        `,
        SectionsInfo: []
    },
    Overview: {
        StaticInfo: `
        <p>
        If the Client requires and authorizes it, the consultant can support an objective, hard evaluation, equivalent
        to a “stress test”, where the available and validated data for the execution of the project are subjected to more
        severe resistance or convenience tests that give confidence and reduce risk to unequivocally answer the
        following questions:<br>
        <ul>
        <li>Is it concluded, without a doubt, that the activity or operation planned by the client is the appropriate option to
        continue the Operations Design Process</li>
        <li>Is it concluded, without a doubt, that the reservoir conditions, the rock geomechanical, geological, fluid
        conditions, and the mechanical conditions of the well or wells object of design, <strong>in no case</strong> show impediment
        or
        presence of high risk factors that could hinder the success of the procedure</li>
        <li>Is it concluded that the exhaustive and in-depth review of the Databases fills all the extremes of amplitude,
        depth and reliability that justify and allow progress in the Operation Design Process</li>
        </ul>
        </p>
        `,
        SectionsInfo: []
    },
    Inputs: {
        StaticInfo: `
        <p>
        Consider uploading or giving the consultant access to the information so that (with prior authorization) the consultant can help you analyze whether the activity or operation planned by the client is the appropriate option to continue the process towards a later stage of study, design or development
        </p>`,
        SectionsInfo: []
    },
    Deliverables: {
        StaticInfo: `
        <p>
        In this section the consultant will provide an objective report with the preliminary analysis, conclusions and
        recommendations about the initial screening and answer whether the activity or operation planned by the client
        is the appropriate option to continue the Process towards a later stage of study, design or development.
        </p>
        `,
        SectionsInfo: []
    }
}